export default function getResource(label) {
    const resources = {
        loading: 'Chargement des récompenses utilisées',
        retry: 'Réessayer'
    };

    return resources[label];
}
